import { NotificationRecipient } from '@/app/entities/Notification'
import { httpClient } from '../http/httpClient'

export interface SendNotificationInput {
  title: string
  message: string
  recipient: NotificationRecipient
}

export const sendNotification = async (payload: SendNotificationInput) => {
  const { data } = await httpClient.post(`/notification`, payload)

  return data
}
